import { QueryClient } from "@tanstack/react-query";

// Neutral defaults on purpose: all realtime/subscription behaviour lives in
// hooks/firestore/core so future fetch-style queries don't inherit it.
export const queryClient = new QueryClient();
